export default "__VITE_PUBLIC_ASSET__ee2a251b__"